export const TITLE_CONTAINER_LABEL_POSITIONS = {
  LEFT: 'left',
  TOP: 'top'
};

export const SLIDER = {
  SLIDE_INTERVAL: 6000,
  TRANSITION_DELAY: 1500
};
